import { Box, Button, Stack, Typography } from "@mui/material"
import { Link as RouterLink } from "react-router-dom"
import MainLayout from "../../layouts/MainLayout"

export default function GenericErrorPage({
  title = "Something went wrong",
  message = "We couldn't load this page, please try again",
  buttonLabel = "Go Back",
  buttonTo = "/home",
}) {
  return (
    <MainLayout>
      <Box
        sx={{
          minHeight: "calc(100vh - 180px)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          px: 2,
        }}
      >
        <Box
          sx={{
            width: "100%",
            maxWidth: 560,
            p: { xs: 3, md: 5 },
            borderRadius: 3,
            border: "1px solid",
            borderColor: "divider",
            boxShadow: 2,
            textAlign: "center",
            bgcolor: "background.paper",
          }}
        >
          <Typography variant="h4" fontWeight={700} gutterBottom>
            {title}
          </Typography>
          <Typography variant="body1" color="text.subcaption" sx={{ mb: 3 }}>
            {message}
          </Typography>
          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={1.5}
            justifyContent="center"
          >
            <Button variant="contained" component={RouterLink} to={buttonTo}>
              {buttonLabel}
            </Button>
          </Stack>
        </Box>
      </Box>
    </MainLayout>
  )
}
